//
//
//
//
//
//
//
//
//

export default {
  name: "ToastComponent",
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 类型 success(成功) fail(失败)
    type: {
      type: String,
      default: "success",
    },
    // 下方文字字号
    size: {
      type: Number,
      default: 18,
    },
    // 标题
    message: {
      type: String,
      default: "",
    },
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
      setTimeout(() => {
        this.showModal = false;
      }, 1000);
    },
    show(val) {
      this.showModal = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/toast/Index.vue